<template>
  <v-container>
    <v-alert outlined color="color_primary" type="info">
      {{ $t("login.logout") }}
    </v-alert>
  </v-container>
</template>

<script>
export default {
  name: "ComponentsLogout",
};
</script>

<style scoped></style>
